import React, {useEffect, useState} from "react";
import {Modal} from "react-bootstrap";
import {getXMLRequestResponseQuotation} from "../../services/cotizador-service";
import {movementIdEmissions, workOrderIdEmissions} from "../../pages/Consultation/Consult";
import Swal from "sweetalert2";
import {getXMLRequestResponseEmission} from "../../services/emission-service";
import format from "xml-formatter";

export default function ModalXMLVisualizer(props) {

    const [request, setRequest] = useState('');
    const [response, setResponse] = useState('');

    useEffect(() => {
        console.log(movementIdEmissions);
        Swal.fire({
            title: 'Cargando XML...',
            showConfirmButton: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading(); //Loading animation
                //Request for XML
                if (movementIdEmissions) {
                    return getXMLRequestResponseQuotation(movementIdEmissions).then(data => {
                        if (data.response.charAt(0) === '{'){ // Is it Json?
                            setResponse(data.response); //Don´t format to XML
                            setRequest(data.request);
                        } else {
                            setResponse(format(data.response));
                            setRequest(format(data.request));
                        }
                    }).then(() => Swal.close()).catch(error => {
                        //If something is wrong...
                        Swal.fire({
                            title: 'Ocurrió un error',
                            text: `No cargaron XML`,
                            icon: 'error',
                            iconColor: 'var(--skrSecondary)',
                            backdrop: `rgba(71, 10, 104, .75)`,
                            showCancelButton: true,
                            showConfirmButton: false,
                            cancelButtonColor: 'var(--skrSecondary)',
                            cancelButtonText: 'Ok'
                        });
                    });
                } else {
                    return getXMLRequestResponseEmission(workOrderIdEmissions).then(data => {
                        if (data.response.charAt(0) === '{'){
                            setResponse(data.response);
                            setRequest(data.request);
                        } else {
                            setResponse(format(data.response));
                            setRequest(format(data.request));
                        }
                    }).then(() => Swal.close()).catch(error => {
                        //If something is wrong...
                        Swal.fire({
                            title: 'Ocurrió un error',
                            text: `No cargaron XML`,
                            icon: 'error',
                            iconColor: 'var(--skrSecondary)',
                            backdrop: `rgba(71, 10, 104, .75)`,
                            showCancelButton: true,
                            showConfirmButton: false,
                            cancelButtonColor: 'var(--skrSecondary)',
                            cancelButtonText: 'Ok'
                        });
                    });
                }
            }
        });
    }, []);

    return (
        <>
            <Modal show={props.isOpen} onHide={props.toggle} size="xl">
                <Modal.Header className="border-0" closeButton>
                    <Modal.Title>
                        <h5 className="mx-4 montserratMedium" style={{color: 'var(--skrPrimary)'}}>Visualizador XML</h5>
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <>
                        <div className="container-fluid justify-content-center" style={{fontSize: '.78rem'}}>
                            <div className="row m-auto">
                                <div className="col">
                                    <h6>XML de envío:</h6>
                                    <textarea name="requestXML" rows="24" cols="60" value={request} disabled={true}/>
                                </div>
                                <div className="col">
                                    <h6>XML de respuesta:</h6>
                                    <textarea name="responseXML" rows="24" cols="60" value={response} disabled={true}/>
                                </div>
                            </div>
                        </div>
                    </>

                </Modal.Body>

                <Modal.Footer>
                    <button className="btn btn-skr-secondary" onClick={props.toggle}>
                        Salir
                    </button>
                </Modal.Footer>

            </Modal>
        </>
    );
}